import * as React from 'react'
import TimeNavbar from '../components/time/TimeNavbar'
import TimeData from '../components/time/TimeData'

const Time = () => {
 
  return (
    <div>
      <TimeNavbar />
      <TimeData />
    </div>
  )
}

export default Time
